import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/fashionable-inc-shopify-plus-partnership-case-study")({
  beforeLoad: () => {
    throw redirect({ to: "/resources/fashionable-inc-partnership-case-study", statusCode: 301 });
  },
});
